import { Container, Subtitle, Title } from './style';
import Layout from '../Layout';

const NotFound = () => {

  return (
    <Layout>
      <Container>
        <Title>404</Title>
        <Subtitle>Página não encontrada</Subtitle>
      </Container>
    </Layout>
  );
};

export default NotFound;
